import {Controller} from 'stimulus';

export default class extends Controller {
  connect() {
    // Add event listeners for visibility and focus/blur changes
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('focus', this.handleWindowFocusChange);
    window.addEventListener('blur', this.handleWindowFocusChange);

    // Initial check for page visibility and focus
    this.updateActiveStatus();
  }

  disconnect() {
    // Clean up event listeners when the controller is disconnected
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('focus', this.handleWindowFocusChange);
    window.removeEventListener('blur', this.handleWindowFocusChange);
  }

  handleVisibilityChange = () => {
    this.updateActiveStatus();
  }

  handleWindowFocusChange = () => {
    this.updateActiveStatus();
  }

  updateActiveStatus() {
    const isPageVisible = !document.hidden;
    const isWindowFocused = document.hasFocus();
    const isActive = isPageVisible && isWindowFocused;

    document.body.dataset.pageVisibilityActive = isActive ? 'true' : 'false'; 
  }
}
